import { Parameter } from '@/backend/models/parameter';
import { useTreeStore } from '../store/TreeStore';
import { ParameterSubjectType } from '@/types/parameterTypes';

export const useParameterIsOperationInput = (parameter: Parameter): boolean => {
  const operation = useTreeStore((state) => state.operations.find((op) => op.id === parameter.subjectId));
  return (parameter.subjectType === ParameterSubjectType.OPERATION && operation?.isInput()) || false;
};
